module.exports = __webpack_public_path__ + "static/media/defense_bundle_icon.74c4b7c1.svg";